import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  DateField,
  Filter,
  TextInput,
  CardActions,
  ListButton,
  SearchInput
} from "react-admin";
import BoolNumField from '../controls/BoolNumField'
import LinkToCreate from './LinkToCreate'

export const QuestionFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="exam_name" alwaysOn placeholder="Exam Name" />
    <TextInput source="question" label="Question" />
    <TextInput source="exam_id" label="Exam id" />
  </Filter>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const ExamActions = ({...props}) => (

  <CardActions style={cardActionStyle}>
      <LinkToCreate exam_id={props.filterValues.exam_id } exam_name={props.filterValues.exam_name}/>
      <ListButton basePath={'/Certifications'} label="Certification List" />
  </CardActions>
);


export const ExamlogList = (props) => (
  <List
    {...props}
    filters={<QuestionFilter />}
    perPage={20}
    sort={{ field: "exam_name", order: "ASC" }}
    actions={<ExamActions />}
    bulkActionButtons={false}
    title= "Exam list / History"
  >
    <Datagrid>
      <TextField source="training_name" label="Training" />
      <TextField source="exam_name" label="Exam Name" />
      <BoolNumField source="ispass" label="Result" />
      <DateField source="exam_date" label="Exam Date" locales="en-us" />
      <ShowButton />
    </Datagrid>
  </List>
);

export default ExamlogList;
